import { useMemo } from "react";
import { StyleSheet, Text, View } from "react-native";

import { useTranslation } from "@luna-restaurant/i18n";
import { Icon, NoticeBox, useCustomTheme } from "@luna-restaurant/ui";

import EditGuestOrderForm from "@/components/forms/EditGuestOrderForm";
import { ChefHatModal } from "@/components/modals/ChefHatModal";
import { GuestOrder } from "@/screens/GuestOrdersScreen";

type EditGuestOrderModalProps = {
  visible: boolean;
  guestOrder?: Partial<GuestOrder> | null;
  onDismiss: () => void;
  onSubmitSuccess?: () => void;
  onSubmitError?: (error: unknown) => void;
};

export function EditGuestOrderModal({
  visible,
  guestOrder,
  onDismiss,
  onSubmitSuccess,
  onSubmitError,
}: EditGuestOrderModalProps) {
  const { colors, fonts } = useCustomTheme();
  const { t } = useTranslation();

  const initialValues = useMemo(() => {
    if (!guestOrder) return undefined;

    return {
      ...guestOrder,
    } satisfies Partial<GuestOrder>;
  }, [guestOrder]);

  return (
    <ChefHatModal
      visible={visible}
      icon={{ icon: "pencil", iconSet: "material-community" }}
      iconSize={50}
      fullWidth
      onDismiss={onDismiss}
    >
      <View style={styles.container}>
        <View style={styles.titleContainer}>
          <Icon
            iconSet="material-community"
            icon="pencil"
            color={colors.success}
          />
          <Text
            style={[styles.titleText, fonts.bold, { color: colors.success }]}
          >
            {t("guestOrders.editModal.title")}
          </Text>
        </View>
        <NoticeBox
          title={t("common.notice")}
          textContent={t("guestOrders.editModal.notice")}
        />
        <EditGuestOrderForm
          initialValues={initialValues}
          onDismiss={onDismiss}
          onSubmitSuccess={onSubmitSuccess}
          onSubmitError={onSubmitError}
        />
      </View>
    </ChefHatModal>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 40,
  },
  titleContainer: {
    flexDirection: "row",
    gap: 8,
  },
  titleText: {
    fontSize: 16,
    lineHeight: 20.8,
  },
});
